import { useEffect } from "react";

import { userManager } from "@/utils";

const LoginPage = () => {
  useEffect(() => {
    userManager.signinRedirect({
      extraQueryParams: {
        userType: "consumer",
      },
    });
  }, []);

  return (
    <div className="public-page-container">
      <p style={{ color: "#172B4D", fontWeight: 500, textAlign: "center" }}>در حال بارگذاری لطفا کمی صبر کنید...</p>
    </div>
  );
};

export default LoginPage;
